/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

export const REMEMBER_ME_STATE_KEY = 'rememberMe';
